import { ActionListItem as ReactActionListItem } from "@certn/cascadia-react/components/action-list/ActionListItem";
import { memo } from "react";

import { CascadiaActionListItemProps } from "./types";

export const ActionListItem = memo(function (
  props: CascadiaActionListItemProps
) {
  // See CHEESE-214 to simplify this stub - the API for ActionListItem should be the same on both platforms.
  return (
    <ReactActionListItem
      {...props}
      centerAlignTrailing={props.variation !== "multi-line"}
      alignItems={props.variation === "multi-line" ? "start" : "center"}
      paddingLeft={props.inset ? "space-4" : "space-0"}
      paddingRight={props.inset ? "space-4" : "space-0"}
    />
  );
});
